export const defaultMeters = () => {
  return [{
    id: 'meter-1',
    label: 'meter-1',
    min: 0,
    max: 100,
    value: 0
  }, {
    id: 'meter-2',
    label: 'meter-2',
    min: 0,
    max: 100,
    value: 0
  }, {
    id: 'meter-3',
    label: 'meter-3',
    min: 0,
    max: 100,
    value: 0
  }, {
    id: 'meter-4',
    label: 'meter-4',
    min: 0,
    max: 100,
    value: 0
  }, {
    id: 'meter-5',
    label: 'meter-5',
    min: 0,
    max: 100,
    value: 0
  }]
}